import LinkButton from "../../../components/linkButton/LinkButton";

import { imgIcon } from "../../../components/linkButton/LinkButtonIcons";
import ViniZapIcon from "../../../assets/icons/about/vini.png";

import { useTranslation } from "react-i18next";

import MySkills from "./MySkills";

//import docEn from "../../../assets/doc/VInicius-Zapala-dos-Santos-resume.pdf"
//import docPt from "../../../assets/doc/VInicius-Zapala-dos-Santos-curriculo.pdf"
import { useEffect, useState } from "react";

import cookies from 'js-cookie'
import MyCertificates from "./MyCertificates";

export default function AboutContents() {
 
/*  const languages = [
    {
      code: 'enUS',
      Doc: docEn,
    },
    {
      code: 'ptBR',
      Doc: docPt,
    }
  ]
*/
  const { t } = useTranslation();
  const currentLanguageCode = cookies.get('i18next') || 'en'
  const [doc, setDocument] = useState()

  /*
  useEffect(() => {
    languages.map((lang) => {
      if (currentLanguageCode === lang.code){
        setDocument(lang.Doc)
      }
    });
  }, [currentLanguageCode, t])
  */
  return (
    <div id="AboutContents">
      
      <div id="AboutMe">
        <div className="TextContainer">
          <div className="Icon" style={animationScale(0.6)}>
            <img className="img" src={ViniZapIcon} alt="ViniZap Logo" />
          </div>
          <div  className="text" style={animationBlurred(0.3)} >
            {t('message')}
          </div>
        </div>
        <div className="SeeMore">
          <h1 className="titleSeeMore" style={animationScale(1.2)}> {t('see-more')} </h1>
          <div className="EasyContacts">
            <LinkButton style={animationBlurred(0.6)} to="https://www.linkedin.com/in/vinicius-zapala-dos-santos" title="LinkedIn" icon={imgIcon.linkedin} />
            <LinkButton style={animationBlurred(0.9)} to="https://github.com/ViniZap4" title="Github"   icon={imgIcon.gitGub}/>
            {/*<LinkButton style={animationBlurred(1.2)} to={doc}  title={t('resume')}   icon={imgIcon.CV}/>*/}

          </div>
        </div>
     
      </div>
      <h1 className="MySkillsTitle" style={animationScale(1.2)}> {t('my-skills')} </h1>

      <div id="MySkills">
        <MySkills />
      </div>

      <h1 className="MyCertificates" style={animationScale(2)}> {t('my-certificate')} </h1>

      <div id="Certificates">
        <MyCertificates />
      </div> 

    </div>
  );
}

export function animationBlurred(daley){
  return({
    animation: `slide-in-blurred-bottom  0.6s ${daley}s cubic-bezier(0.230, 1.000, 0.320, 1.000) both`,
  })
}

export function animationScale(daley){
  return({
    animation: `scale-in-center 0.6s ${daley}s cubic-bezier(0.250, 0.460, 0.450, 0.940) both`
  })
}

